import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';


const SimpleDialog = ({ open, onClose, children, onSubmit, title, hasSubmit, ...props }) => {

  const handleClose = () => {
    onClose(!open);
  };

  const handleSubmit = () => {
    handleClose();
    onSubmit();
  };

  const actions = [
    <FlatButton
      label="Cancel"
      primary
      onTouchTap={handleClose}
    />,
    <FlatButton
      label="Submit"
      primary
      keyboardFocused
      onTouchTap={handleSubmit}
    />,
  ];

  return (
    <div>
      <Dialog
        title={title}
        actions={hasSubmit ? actions : []}
        modal={false}
        open={open}
        onRequestClose={handleClose}
        {...props}
      >
        {children}
      </Dialog>
    </div>
  );
};

SimpleDialog.defaultProps = {
  open: false,
  onClose: false,
  children: [],
  onSubmit: () => {},
  title: '',
  hasSubmit: true,
};
SimpleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default SimpleDialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/SimpleDialog.js